<template>
  <Card>
    <h1 slot="Title">Cost Center</h1>
    <div slot="MainContent">
      <p>
        <b>Cost Center (76VV0065)</b>: Cost Centers are cost objects in the Controlling Area of GFEBS that represent an organizational unit where cost are incurred.
           The organizational unit can be defined based on functional requirements, allocation criteria, physical location, or responisbility for costs.
      </p>
        <p>
           Cost Centers represent the organizations hierarchical structure found in its Table of Distribution and Allowance (TDA) or Table of Organization and
           Equipment (TO&E).
        </p>
      <p>
        202011D20_ A76VV 131096QLOG 6100.2617 WBS, Internal Order or <b><u>76VV0065</u></b> 1000000067 021001
      </p>
    </div>
<p><strong>Cost Center</strong></p>
<p><strong>&nbsp;</strong></p>
<p><strong>Instructor notes:&nbsp; </strong><strong>Army Management Structure (Federated ERPs) Guide </strong><strong>&gt;chap 9&gt; use the word document to explain cost centers and you will use the spreadsheet from chap 8&gt;tab 2&gt; for cost centers</strong></p>
<p>&nbsp;&nbsp;&nbsp; <strong>Cost Center (76VV0065).</strong> Cost Centers are cost objects in the Controlling Area of GFEBS that reflect an organization&rsquo;s command and control structure where costs are incurred. The organizational unit can be defined based on functional requirements, allocation criteria, physical location, or responsibility for costs. Cost Centers represent the organization&rsquo;s hierarchical structure found in its Table of Distribution and Allowance (TDA) or Table of Organization and Equipment (TO&amp;E).</p>
<p><strong>Cost Centers:</strong></p>
<ul>
<li>Clearly define a responsibility area where costs are incurred</li>
<li>Enable informal funds distributions from Funds Centers to subordinate organizations with the related Cost Center group.</li>
<li>Do reflect the organizational structure, which usually follows the chain of command.</li>
<li>Are organized into Cost Center groups based on the organization structure. Each Cost Center group is usually related to one Funds Center.</li>
<li>Can be funded by Funds Centers outside an organization&rsquo;s Funds Center structure.</li>
</ul>
<p><strong>Position&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Represents&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; Example</strong></p>
<p>&nbsp;6-9&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Last 4 characters of Fund Center&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; 76VV</p>
<p>10-11&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Specific organization and function&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; 00</p>
<p>12-15&nbsp; &nbsp; Responsible for incurring and capturing cost&nbsp;&nbsp;&nbsp; &nbsp; 65</p>
<p><strong>NOTE: Structure and Critical Fields</strong>: The GFEBS Cost Center data element is 10 numeric characters. Derivation rules are used to map each Cost Center group to a Funds Center. The Alpha numeric is used for training purposes because the training client &ldquo;TED&rdquo; is not update to the current production system.</p>
  </Card>
</template>

<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'Cost Center',
  
  data() {
    return {
    }
  }
  
}
</script>